"use strict";

const DeletionRequestsCtrl = function ($http, Notification) {
  var ctrl = this;

  ctrl.requests = [];

  ctrl.$onInit = function () {
    ctrl.reloadRequests();
  };

  ctrl.reloadRequests = function () {
    $http.get('/api/deletionrequests').then(
      function (data) {
        ctrl.requests = data.data;
      });
  };

  ctrl.acceptRequest = function (item) {
    item.state = "ACCEPTED";
    $http.post('/api/deletionrequests/' + item.uuid, "ACCEPTED").then(function () {
      ctrl.reloadRequests();
      Notification.success("Der Löschvorgang wurde erfolgreich abgeschlossen.");
    }, function () {
      ctrl.reloadRequests();
      Notification.error("Der Löschvorgang konnte nicht abgeschlossen werden.");
    });
  };

  ctrl.declineRequest = function (item) {
    item.state = "DECLINED";
    $http.post('/api/deletionrequests/' + item.uuid, "DECLINED").then(function () {
      ctrl.$reloadRequests();
      Notification.success("Der Löschantrag wurde erfolgreich abgelehnt.");
    }, function () {
      ctrl.reloadRequests();
      Notification.error("Der Löschantrag konnte nicht abgelehnt werden.");
    });
  };

  ctrl.removeRequest = function (item) {
    $http.delete('/api/deletionrequests/' + item.uuid).then(function () {
      ctrl.reloadRequests();
      Notification.success("Der Löschantrag wurde erfolgreich entfernt.");
    }, function () {
      ctrl.reloadRequests();
      Notification.error("Der Löschantrag konnte nicht entfernt werden.");
    });
  };
};

DeletionRequestsCtrl.$inject = ['$http', 'Notification'];

module.exports = {
  template: require('./deletionrequests.html'),
  controller: DeletionRequestsCtrl
};



// WEBPACK FOOTER //
// ./src/main/webapp-files/modules/settings/components/deletionrequests/deletionrequests.component.js